export default __webpack_public_path__ + "static/media/portfolio-211.a28b26a3.jpg";